"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bignumber_js_1 = require("bignumber.js");
var LocaleUtil = require("./LocaleValue");
var Proxy_1 = require("./Proxy");
var prototype = String.prototype;
if (prototype.contains === undefined) {
    prototype.contains = function (str) {
        return this.indexOf(str) >= 0;
    };
}
if (prototype.startsWith === undefined) {
    prototype.startsWith = function (prefix) {
        return this.indexOf(prefix) === 0;
    };
}
if (prototype.endsWith === undefined) {
    prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) >= 0;
    };
}
function normaliseMobileNumber(mobile) {
    if (!mobile) {
        return mobile;
    }
    if (mobile) {
        mobile = mobile.replace(/\D/g, "");
    }
    if (mobile.startsWith("00")) {
        mobile = mobile.substring(2);
    }
    else if (mobile.startsWith("+")) {
        mobile = mobile.substring(1);
    }
    else if (mobile.startsWith("0")) {
        mobile = "971" + mobile.substring(1);
    }
    return mobile;
}
exports.normaliseMobileNumber = normaliseMobileNumber;
function isEmptyStringOrNull(value) {
    if (!value)
        return true;
    if (/^\s*$/.test(value))
        return true;
    return false;
}
exports.isEmptyStringOrNull = isEmptyStringOrNull;
function isEmailAddress(email) {
    if (!email)
        return false;
    var emailRegx = /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    return emailRegx.test(email);
}
exports.isEmailAddress = isEmailAddress;
function replaceExceptFirst(test, regex, replace) {
    if (replace === void 0) { replace = ""; }
    var count = 0;
    return test.replace(regex, function (match) {
        count++;
        if (count === 1) {
            return match;
        }
        else {
            return replace;
        }
    });
}
exports.replaceExceptFirst = replaceExceptFirst;
function toFixed(num, fixed) {
    if (num == undefined)
        return "";
    var re = new RegExp("^-?\\d+(?:\.\\d{0," + (fixed || -1) + "})?");
    var match = num.toString().match(re);
    if (match) {
        return match[0];
    }
    return "";
}
exports.toFixed = toFixed;
function toNumberString(input, maxDecimals) {
    if (maxDecimals === void 0) { maxDecimals = 6; }
    if (input == undefined)
        return undefined;
    var isNeg = false;
    var value;
    if (typeof input === "number") {
        isNeg = input < 0;
        value = new bignumber_js_1.default(input).toFixed();
    }
    else {
        isNeg = (input + "").startsWith("-");
    }
    value = (input + "").replace(/[^\d.]/g, "");
    value = replaceExceptFirst(value, /\./g);
    var numberValue = new bignumber_js_1.default(value);
    if (numberValue.isNaN())
        return undefined;
    var ps = numberValue.toFixed();
    var pxDotIx = ps.indexOf(".");
    var dotIx = value.indexOf(".");
    if (dotIx === -1) {
        return (isNeg ? "-" + ps.toString() : ps.toString()) + "";
    }
    else {
        if (dotIx === (value.length - 1) && maxDecimals > 0) {
            return ps + ".";
        }
        else {
            if (pxDotIx === -1 && maxDecimals > 0) {
                var dec = value.substr(dotIx + 1).replace(/\D/g, "");
                if (dec.endsWith("0")) {
                    return ps + "." + dec.substr(0, maxDecimals);
                }
                return ps + ".";
            }
            var pcount = ps.length - pxDotIx - 1;
            if (pcount < maxDecimals) {
                return ps;
            }
            else {
                return toFixed(ps, maxDecimals);
            }
        }
    }
    return (isNeg ? "-" + ps.toString() : ps.toString()) + "";
}
exports.toNumberString = toNumberString;
function lvString(values) {
    var p = new Proxy_1.default(StringHandler);
    return p.proxy(values);
}
exports.lvString = lvString;
function lvValues(values) {
    var p = new Proxy_1.default(LVHandler);
    return p.proxy(values);
}
exports.lvValues = lvValues;
var StringHandler = {
    get: function (obj, prop, proxy) { return prop in obj ?
        LocaleUtil.getLocalValue(obj[prop]) : prop; },
};
var LVHandler = {
    get: function (obj, prop, proxy) { return prop in obj ? obj[prop] : prop; },
};
//# sourceMappingURL=StringUtils.js.map